export enum NumberFormatNames {
  Currency = 'currency',
  Number = 'number',
  NumberWith2Decimals = 'numberWith2Decimals',
  RoundedNumber = 'roundedNumber',
  RoundedNrNoGrouping = 'roundedNrNoGrouping'
}
